module.exports = __webpack_public_path__ + "static/media/Vote_Center_Logo.b53b2272.png";